import { ValueOf } from './util';

/** ファイル種別のenum */
export const EBulkGrantFileType = {
  APP_USER: 'アプリユーザ',
  PHYSICAL_PREPAID_CARD: '物理プリペイドカード',
} as const;

/** ファイル種別（ラジオボタン表示用）のenum */
export const EBulkGrantRadioButtonFileType = {
  APP_USER: 'ユーザID、または外部ユーザIDを指定',
  PHYSICAL_PREPAID_CARD: '物理プリペイドカード番号を指定',
} as const;

export type BulkGrantFileTypeKey = keyof typeof EBulkGrantFileType;
export type BulkGrantFileTypeValue = ValueOf<typeof EBulkGrantFileType>;

export const bulkGrantFileTypeKeys = Object.keys(EBulkGrantFileType) as (BulkGrantFileTypeKey[]);

/** v-select用items */
export const bulkGrantRadioButtonFileTypeItems = bulkGrantFileTypeKeys
  .map((key) => ({
    title: EBulkGrantRadioButtonFileType[key],
    value: key,
  }));
